import Navigation from "@/components/Navigation";

const Peels = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">Chemical Peels</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <img
                src="/lovable-uploads/db2851b7-7b77-40f2-a002-a0521f96e1fc.png"
                alt="Chemical Peels"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
            </div>
            <div>
              <p className="text-lg mb-6">
                Our chemical peel treatments improve skin texture, reduce signs of aging, and address various skin concerns through controlled exfoliation.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">Benefits</h3>
                  <p>Improved skin texture, reduced fine lines, and more even skin tone.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Types of Peels</h3>
                  <p>Light, medium, and deep peels customized to your needs.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Recovery</h3>
                  <p>Minimal downtime with proper aftercare instructions provided.</p>
                </div>
              </div>
              <a
                href="https://na02.patientnow.com/a/EVOLVEDYOU"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Peels;